import axios from "../../utils/axios";

async function fetchList(params) {
  return await axios.get(`/single/shop-user`, { params });
}

async function activateUser(id) {
  return await axios.patch(`/single/shop-user/${id}/activate`);
}

async function deactivateUser(id) {
  return await axios.patch(`/single/shop-user/${id}/deactivate`);
}

async function inviteUser(data) {
  return await axios.post(`/single/shop-user`, data);
}

async function editUser(id, data) {
  return await axios.patch(`/single/shop-user/${id}`, data);
}

async function removeUser(id) {
  return await axios.delete(`/single/shop-user/${id}`);
}

export const CustomerService = {
  fetchList,
  activateUser,
  deactivateUser,
  inviteUser,
  editUser,
  removeUser,
};
